import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=1b4608d8&"
import script from "./HeadInfo.vue?vue&type=script&lang=js&"
export * from "./HeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4608d8')) {
      api.createRecord('1b4608d8', component.options)
    } else {
      api.reload('1b4608d8', component.options)
    }
    module.hot.accept("./HeadInfo.vue?vue&type=template&id=1b4608d8&", function () {
      api.rerender('1b4608d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/HeadInfo.vue"
export default component.exports